import Vue from "vue";
import { validate } from "multicoin-address-validator";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  configure
} from "vee-validate";
import {
  required,
  email,
  numeric,
  alpha_num,
  alpha_dash
} from "vee-validate/dist/rules";
import i18n from "./i18n";
import Viewer from "v-viewer";

extend("required", required);
extend("positive", value => {
  const float = Number.parseFloat(value);
  return !Number.isNaN(float) && float > 0;
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    switch (values._rule_) {
      case "required": {
        return i18n.t("is Empty", [values._field_]);
      }
      case "email": {
        return i18n.t("Incorrect email format");
      }
      case "numeric": {
        return i18n.t("please enter numeric");
      }
      case "alpha_num":
      case "alpha_dash": {
        return i18n.t("Incorrect passport format");
      }
    }
  }
});

extend("required", required);

extend("email", email);

extend("numeric", numeric);

extend("alpha_num", alpha_num);

extend("alpha_dash", alpha_dash);

extend("stateCheck", value => {
  const invalidArray = ["NY", "NEWYORK", "纽约"];
  let bRet = true;
  invalidArray.forEach(item => {
    let tempValue = value.replace(/\s*/g, "");
    if (item === tempValue.toUpperCase()) {
      bRet = false;
    }
  });
  if (!bRet) {
    return i18n.t("State Check MSG");
  }
  return true;
});
extend("cityCheck", value => {
  const invalidArray = ["NY", "NEWYORK", "纽约", "NEWYORKCITY"];
  let bRet = true;
  invalidArray.forEach(item => {
    let tempValue = value.replace(/\s*/g, "");
    if (item === tempValue.toUpperCase()) {
      bRet = false;
    }
  });
  if (!bRet) {
    return i18n.t("State Check MSG");
  }
  return true;
});

extend("alpha_address", value => {
  const reg = /\p{Unified_Ideograph}/u;
  if (reg.test(value)) {
    return i18n.t("Receipt Address");
  }
  return true;
});

extend("alpha_num_space", value => {
  const reg = /^[A-Za-z0-9 ]+$/;
  if (!reg.test(value)) {
    return i18n.t("Receipt Bank Account Number");
  }
  return true;
});

extend("erc20_address", value => {
  const isValid = validate(value, "Tether");
  if (!isValid) {
    return i18n.t("Incorrect wallet address");
  }
  return true;
});

extend("telegram", value => {
  if (!value.startsWith("@")) {
    return i18n.t("telegram_error_message");
  }
  return true;
});

Vue.use(Viewer, {
  Options: {
    inline: true,
    button: true,
    navbar: false,
    title: true,
    toolbar: false,
    tooltip: true,
    movable: false,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    loading: true,
    url: "data-source"
  }
});
